function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.032 1.5864C12.8237 0.730868 14.1763 0.730869 14.968 1.5864L17.2407 4.04252C17.5846 4.41423 18.0568 4.64162 18.5619 4.67878L21.8992 4.9243C23.0616 5.00983 23.905 6.06733 23.7297 7.21969L23.2264 10.5279C23.1503 11.0286 23.2669 11.5395 23.5527 11.9576L25.4415 14.7199C26.0995 15.6821 25.7985 17.0007 24.7882 17.5822L21.888 19.2514C21.4491 19.504 21.1223 19.9137 20.9737 20.3979L19.9917 23.5969C19.6496 24.7112 18.431 25.298 17.3465 24.8707L14.2332 23.6439C13.762 23.4583 13.238 23.4583 12.7668 23.6439L9.65346 24.8707C8.569 25.298 7.35036 24.7112 7.0083 23.5969L6.02632 20.3979C5.8777 19.9137 5.55095 19.504 5.11201 19.2514L2.21175 17.5822C1.20151 17.0007 0.900528 15.6821 1.55845 14.7199L3.44726 11.9576C3.73311 11.5395 3.84973 11.0286 3.77357 10.5279L3.27032 7.21969C3.09503 6.06733 3.93836 5.00983 5.10083 4.9243L8.43811 4.67878C8.94319 4.64162 9.41536 4.41423 9.75932 4.04252L12.032 1.5864Z",
  fill: "#3EDF85"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.59375 13.3702L11.3377 17.1562L16.4294 12.0072L19.125 9.28125",
  stroke: "#F5FAFF",
  strokeWidth: 3
});

function SvgVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.8f12e2ed.svg";
export { ForwardRef as ReactComponent };